export const plannerItems = [
  {
    id: 'hire_bootstrap_create_vacancy',
    tone: 'calm',
    eyebrow: 'Start here',
    title: 'Создайте первую вакансию',
    text: 'Hire OS начнёт планировать найм после вакансии: AI сможет искать кандидатов, считать match и строить pipeline.',
    meta: ['нет активных вакансий', 'нет кандидатов', 'данные очищены'],
    why: ['новый workspace пустой', 'нельзя планировать интервью/офферы без вакансии'],
    risks: [],
    nextBestAction: 'Создать вакансию или импортировать резюме',
    score: 100,
    priority: 'P1',
    confidence: 100,
    signals: {},
    actions: [
      { label: 'Создать вакансию', action: 'job_create' },
      { label: 'Загрузить резюме', action: 'review_candidates', variant: 'secondary' }
    ]
  }
];

export const jobs = [];
export const candidates = [];
export const pipeline = { New: [], Interview: [], Offer: [], Hired: [] };

export const automations = [
  ['Confirm meetings', 'За 15 минут до интервью AI отправит подтверждение.', 'toggle_confirm_meetings'],
  ['Meeting links', 'За 5 минут до начала AI пришлёт ссылку.', 'toggle_meeting_links'],
  ['Candidate market risk', 'Поднимает наверх кандидатов, которых могут схантить.', 'toggle_market_risk'],
  ['Offer SLA', 'Напоминает, если оффер зависает дольше допустимого срока.', 'toggle_offer_sla']
];

export const careerFallback = {
  source: 'mock',
  emptyState: true,
  isNewUser: true,
  profile: {
    headline: '',
    summary: '',
    seniority: '',
    marketValue: '',
    cvScore: 0,
    visibility: 'Not configured',
    skills: [],
    gaps: [],
    isConfigured: false
  },
  preferences: {
    targetRoles: [],
    salaryMin: null,
    currency: '',
    locations: [],
    remote: '',
    autoApplyRules: { enabled: false, minScore: 92, approveBeforeApply: true, requireCvAdaptation: true, maxApplicationsPerDay: 5 }
  },
  intentState: 'new_user',
  setupChecklist: [
    { id: 'upload_cv', title: 'Загрузить CV', done: false },
    { id: 'set_goals', title: 'Настроить цели', done: false },
    { id: 'find_jobs', title: 'Запустить поиск вакансий', done: false }
  ],
  careerFeed: [
    {
      id: 'career_bootstrap_upload_cv', tone: 'urgent', priority: 'P1', score: 100, eyebrow: 'Start here',
      title: 'Загрузите первое резюме', text: 'Careeva начнёт анализ, matching и planner только после CV.',
      meta: ['PDF / DOCX / TXT', 'данные пока пустые'],
      why: ['нет активного CV', 'нельзя честно считать match score без профиля'], risks: [], nextBestAction: 'Открыть вкладку CV', confidence: 100,
      actions: [{ label: 'Открыть CV', action: 'career_cv_upload' }]
    }
  ],
  candidateDailyPlanner: {
    tasks: [],
    summary: { scoreAverage: 0, p1Count: 1, p2Count: 0, nextBestAction: 'Загрузить первое резюме', freeSlots: [], focus: 'setup' },
    emptyState: true
  },
  jobMatches: [],
  applications: [],
  careerAnalytics: { topMatches: 0, saved: 0, applied: 0, cvScore: 0, marketValue: '', approvalQueue: 0, autoApplyCandidates: 0 },
  jobSearchEngine: { autoApplyRules: { enabled: false, minScore: 92, approveBeforeApply: true, requireCvAdaptation: true, maxApplicationsPerDay: 5 }, scoreFormula: 'disabled until CV upload', decisionBands: {} },
  cvManagement: {
    hasCv: false,
    activeCv: null,
    documents: [],
    versions: [],
    events: [],
    uploadHints: ['Upload CV to unlock parsing, job matching and CV optimization.']
  },
  optimizer: { analysis: null, cvVersions: [], history: [] },
  actionHistory: []
};
